import { render, staticRenderFns } from "./dm-detail-video.vue?vue&type=template&id=757ab411&scoped=true"
import script from "./dm-detail-video.vue?vue&type=script&lang=js"
export * from "./dm-detail-video.vue?vue&type=script&lang=js"
import style0 from "./dm-detail-video.vue?vue&type=style&index=0&id=757ab411&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757ab411",
  null
  
)

export default component.exports